// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"Loading_loading-container__XBrKZ","loading-text":"Loading_loading-text__2Rdeu","loading-indicator":"Loading_loading-indicator__30Ppp"};